export default value => {
  return Object.keys(value).reduce((acc, key) => {
    return acc.concat(value[key]);
  }, []);
}
